<template>
  <div class="main">
    <div
      class="dropzone-container"
      :style="isDragging && 'border-color: green;'"
      @dragover="dragover"
      @dragleave="dragleave"
      @drop="drop"
    >
      <input
        id="fileInput"
        ref="file"
        type="file"
        :multiple="multiple"
        name="file"
        class="hidden-input"
        :accept="acceptTypes.join(',')"
        @change="onChange"
      >

      <label
        for="fileInput"
        class="file-label"
      >
        <div v-if="isDragging">Release to drop files here.</div>
        <div v-else>Drop files here or <u>click here</u> to upload.</div>
      </label>
      <div class="d-flex flex-column">
        <label
          v-if="acceptTypes"
          class="file-restriction"
        >
          {{ acceptTypes.join(', ') }} only.
        </label>
        <label
          v-if="maxFileSizeBytes"
          class="file-restriction"
        >
          Max {{ maxFileSizeBytes / 1024 }}kb
        </label>
      </div>
      <div
        v-if="files.length"
        class="preview-container mt-4"
      >
        <div
          v-for="file in files"
          :key="file.name"
          class="preview-card"
        >
          <div class="align-center">
            {{ file.name }}
          </div>
          <div>
            <button
              class="btn btn-danger"
              type="button"
              title="Remove file"
              @click="remove(files.indexOf(file))"
            >
              <TrashIcon class="text-white" />
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100">
      <button
        class="btn btn-primary w-50"
        :disabled="files.length === 0"
        @click="submit"
      >
        Upload
        <i class="fa fa-upload" />
      </button>
    </div>
  </div>
</template>

<script>
import TrashIcon from "@/components/icons/TrashIcon.vue";

export default {
  components: {TrashIcon},
  props: {
    acceptTypes: {
      type: Array,
      required: true,
    },
    maxFileSizeBytes: {
      type: Number,
      default: 250 * 1024, // 250 kb
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  emits: ['handleUploadedFiles'],
  data() {
    return {
      files: [],
      isDragging: false,
    };
  },
  methods: {
    validateFile(file) {
      const filetype = file.type.substring(file.type.indexOf('/') + 1);
      const cleanedFileTypes = [];
      this.acceptTypes.forEach((str) => {
        cleanedFileTypes.push(str.replace('.', ''));
      });

      return file.size <= this.maxFileSizeBytes && cleanedFileTypes.includes(filetype);
    },
    onChange() {
      if (this.multiple) {
        for (const file of this.$refs.file.files) {
          if (this.validateFile(file)) {
            this.files.push(file);
          }
        }
      }

      else {
        const file = this.$refs.file.files[0];
        if (this.validateFile(file)) {
          this.files = [];
          this.files.push(file);
        }
      }
    },
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();

      if (this.files && !this.multiple) {
        this.$refs.file.files = e.dataTransfer.files;
        this.onChange();
      }

      this.isDragging = false;
    },
    remove(i) {
      this.files.splice(i, 1);
    },
    submit(e) {
      e.preventDefault();
      this.$emit("handleUploadedFiles", this.files);
    }
  },
};
</script>

<style scoped>
.main {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  text-align: center;
  width: 100%;
}

.dropzone-container {
  padding: 4rem;
  background: #f7fafc;
  border: 2px dashed;
  border-color: #9e9e9e;
  width: 100%;
}

.hidden-input {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
}

.file-label {
  font-size: 20px;
  display: block;
  cursor: pointer;
}

.preview-container {
  display: flex;
  margin-top: 2rem;
}

.preview-card {
  display: flex;
  border: 1px solid #a2a2a2;
  padding: 5px;
  margin-left: 5px;
  gap: 5px;
}

.align-center {
  align-self: center;
}
</style>
